import { useMemo } from 'react';

import type { TNotification } from '@src/shared/types/notification';

type TDateSplitMap = {
  Today: TNotification[];
  Yesterday: TNotification[];
  Last7Days: TNotification[];
  Older: TNotification[];
};

export const useDateSplitter = (
  notifications: TNotification[] = []
): TDateSplitMap => {
  return useMemo(() => {
    const today = new Date();
    const startOfToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const startOfYesterday = new Date(startOfToday);
    startOfYesterday.setDate(startOfYesterday.getDate() - 1);
    const startOfLast7Days = new Date(startOfToday);
    startOfLast7Days.setDate(startOfLast7Days.getDate() - 7);

    const result: TDateSplitMap = {
      Today: [],
      Yesterday: [],
      Last7Days: [],
      Older: [],
    };

    for (const n of notifications) {
      const createdAt = new Date(n.created_at);

      if (createdAt >= startOfToday) {
        result.Today.push(n);
      } else if (createdAt >= startOfYesterday && createdAt < startOfToday) {
        result.Yesterday.push(n);
      } else if (createdAt >= startOfLast7Days) {
        result.Last7Days.push(n);
      } else {
        result.Older.push(n);
      }
    }

    return result;
  }, [notifications]);
};
